import { Component, OnDestroy, OnInit } from '@angular/core';
import { ArhivskaKnjigaClient } from '@kodit/core/data-api';
import { SharedService } from '@kodit/core/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-arhivska-knjiga-page',
  templateUrl: './arhivska-knjiga-page.component.html',
  styleUrls: ['./arhivska-knjiga-page.component.scss'],
})
export class ArhivskaKnjigaPageComponent implements OnInit, OnDestroy {
  _subs: Subscription = new Subscription();

  constructor(
    private _client: ArhivskaKnjigaClient,
    private _sharedService: SharedService
  ) {}

  ngOnInit(): void {}

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
